<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar a conta <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(account) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_ACCOUNT_MUTATION,
          variables: {
            id: account.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyAccount.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_ACCOUNT_MUTATION = gql `
  mutation($id: ID!) {
    destroyAccount(id: $id) {
      account {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>